import { createAsyncThunk } from "@reduxjs/toolkit";
import { getIcons } from "../../api/get-icons";

const getIconsAction = createAsyncThunk("icons/getIcons", async () => {
  return await getIcons();
});

export default getIconsAction;
